/**
 * Readiness Service
 * API functions for readiness checks
 */

import { httpClient } from '@/api/http/client'

/**
 * Readiness check response
 */
export interface ReadinessResponse {
  status: string
  [key: string]: unknown
}

/**
 * Readiness service API functions
 */
export const readinessService = {
  /**
   * Get readiness check status
   */
  getReadiness: (): Promise<ReadinessResponse> => {
    return httpClient.get<ReadinessResponse>('/ready')
  },
}
